<nb-card [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-card-header>
    <div>
      <button
        [ngClass]="menu == 'info' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'info' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltipPlacement="bottom"
        (click)="selectMenu('info')"
      >
        <nb-icon class="button-icon" icon="info-outline"></nb-icon>
        <span>{{ "common.info" | translate }}</span>
      </button>

      <nb-select
        [disabled]="locked"
        class="type-select"
        size="small"
        placeholder="Chọn trạng thái"
        [(ngModel)]="task.status"
        [status]="task.status >= 0 ? statusList[task.status].status : 'default'"
      >
        <nb-option *ngFor="let opt of statusList" [value]="opt.value">
          {{ opt.title }}
        </nb-option>
      </nb-select>
    </div>

    <button
      class="cancel"
      nbButton
      outline
      status="danger"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body [nbSpinner]="locked" nbSpinnerStatus="danger">
    <div class="row">
      <div class="col-12 col-sm-9">
        <div class="row" *ngIf="!customer || !customer?.id">
          <div class="col-6">
            <div class="form-group">
              <label class="label">Chọn đối tượng </label>
              <nb-select
                size="small"
                [(ngModel)]="task.objectType"
                [disabled]="mode === 'view'"
              >
                <nb-option *ngFor="let opt of objectTypes" [value]="opt.value">
                  {{ opt.title }}
                </nb-option>
              </nb-select>
            </div>
          </div>
          <div class="col-6">
            <div *ngIf="task.objectType === 'customer'" class="form-group">
              <ngx-view-selection-object
                *ngIf="mode !== 'view'"
                [shopId]="shopId"
                [objectType]="task.objectType"
                [objectId]="task.customerId"
                [objectName]="task.customerName"
                [objects]="customers"
                (objectChange)="objectChange($event)"
              >
              </ngx-view-selection-object>
              <h6 *ngIf="mode === 'view'">
                {{ task.customerName }}
              </h6>
            </div>
            <div *ngIf="task.objectType === 'supplier'" class="form-group">
              <ngx-view-selection-object
                *ngIf="mode !== 'view'"
                [shopId]="shopId"
                [objectType]="task.objectType"
                [objectId]="task.supplierId"
                [objectName]="task.supplierName"
                [objects]="suppliers"
                (objectChange)="objectChange($event)"
              >
              </ngx-view-selection-object>
              <h6 *ngIf="mode === 'view'">
                {{ task.supplierName }}
              </h6>
            </div>
            <div *ngIf="task.objectType === 'employee'" class="form-group">
              <ngx-view-selection-object
                *ngIf="mode !== 'view'"
                [shopId]="shopId"
                [objectType]="task.objectType"
                [objectId]="task.employeeId"
                [objectName]="task.employeeName"
                [objects]="employees"
                (objectChange)="objectChange($event)"
              >
              </ngx-view-selection-object>
              <h6 *ngIf="mode === 'view'">
                {{ task.employeeName }}
              </h6>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="customer && customer?.id != ''">
          <div class="col-12">
            <div class="form-group">
              <label class="label">
                Khách hàng
                <b class="text-primary"> {{ customer.fullName }}</b>
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="label">
                <span>
                  <nb-icon
                    [icon]="
                      task.priority >= 0
                        ? priorities[task.priority].icon
                        : 'eye-off-2-outline'
                    "
                    [status]="
                      task.priority >= 0
                        ? priorities[task.priority].status
                        : 'default'
                    "
                  ></nb-icon>
                  Công việc
                </span>

                <nb-select
                  class="type-select"
                  size="small"
                  placeholder="Chọn mức độ"
                  [(ngModel)]="task.priority"
                  [status]="
                    task.priority >= 0
                      ? priorities[task.priority].status
                      : 'default'
                  "
                >
                  <nb-option *ngFor="let opt of priorities" [value]="opt.value">
                    {{ opt.title }}
                  </nb-option>
                </nb-select>
              </label>

              <!-- <input
                type="text"
                nbInput
                fullWidth
                class="form-control"
                placeholder="Nhập tên công việc"
                id="title"
                [(ngModel)]="task.title"
              /> -->

              <textarea
                nbInput
                fullWidth
                class="form-control"
                placeholder="Nhập tên công việc"
                id="title"
                [(ngModel)]="task.title"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <nb-accordion multi class="form-group">
              <nb-accordion-item expanded>
                <nb-accordion-item-header>
                  <label class="label">
                    <a (click)="editDescription()" class="text-primary link">
                      <nb-icon icon="file-text-outline"></nb-icon>
                      Nội dung chi tiết
                    </a>
                  </label>
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                  <ngx-view-document
                    *ngIf="!isEditDesc"
                    [content]="task.description"
                    (click)="editDescription()"
                  >
                  </ngx-view-document>

                  <ngx-editor-document
                    *ngIf="isEditDesc"
                    [(ngModel)]="task.description"
                  ></ngx-editor-document>

                  <label *ngIf="isEditDesc && mode === 'edit'" class="label">
                    <a (click)="saveDescription()" class="text-primary link">
                      <nb-icon icon="save-outline"></nb-icon>
                      Lưu
                    </a>

                    <a (click)="closeDescription()" class="text-danger link">
                      <nb-icon icon="close-circle-outline"></nb-icon>
                      Đóng
                    </a>
                  </label>
                </nb-accordion-item-body>
              </nb-accordion-item>

              <nb-accordion-item *ngIf="task.customerId">
                <nb-accordion-item-header>
                  <label class="label">
                    <a
                      *ngIf="!receiptLinked"
                      (click)="linkReceipt()"
                      class="text-primary link"
                    >
                      <nb-icon icon="link-outline"></nb-icon>
                      Đính kèm đơn hàng
                    </a>

                    <a
                      *ngIf="receiptLinked"
                      (click)="unlinkReceipt()"
                      class="text-danger link"
                    >
                      <nb-icon icon="link-2-outline"></nb-icon>
                      Gỡ đính kèm đơn hàng:
                      {{ task.receipt.issueDate | date : "dd/MM/yyyy" }}
                    </a>
                  </label>
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                  <div
                    *ngIf="receiptLinked && task.receipt"
                    class="table-responsive"
                  >
                    <table class="table table-striped">
                      <thead class="thead-light">
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Tên hàng</th>
                          <th scope="col">ĐVT</th>
                          <th scope="col" class="col-number">Đơn giá</th>
                          <th scope="col" class="col-number">Số lượng</th>
                          <th scope="col" class="col-number">$ giảm</th>
                          <th scope="col" class="col-number">Thành tiền</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="
                            let itemDetail of task.receipt.receiptDetails;
                            let i = index
                          "
                        >
                          <td class="col-no">
                            {{ i + 1 }}
                          </td>
                          <td>
                            {{ itemDetail.productName }}
                          </td>
                          <td>
                            {{ itemDetail.productUnitName }}
                          </td>
                          <td class="col-number">
                            {{ itemDetail.price | number }}
                          </td>
                          <td class="col-number">
                            {{ itemDetail.quantity | number }}
                          </td>
                          <td class="col-number">
                            {{ itemDetail.discountAmount | number }}
                          </td>
                          <td class="col-number">
                            <strong>{{ itemDetail.amount | number }}</strong>
                          </td>
                        </tr>
                      </tbody>

                      <tfoot>
                        <tr>
                          <td class="col-label" colspan="4">
                            <strong class="text-hint">Tổng cộng</strong>
                          </td>
                          <td class="col-number">
                            <strong class="text-primary">
                              {{ task.receipt.totalQuantity | number }}
                            </strong>
                          </td>
                          <td></td>
                          <td class="col-number">
                            <strong class="text-primary">
                              {{ task.receipt.detailAmount | number }}
                            </strong>
                          </td>
                        </tr>

                        <tr *ngIf="task.receipt.discountAmount > 0">
                          <td class="col-label" colspan="4">
                            <strong class="text-hint">Chiết khấu</strong>
                          </td>
                          <td colspan="3" class="col-number">
                            <strong class="text-primary">
                              {{ task.receipt.discountAmount | number }}
                            </strong>
                          </td>
                        </tr>

                        <tr
                          *ngIf="
                            task.receipt.totalAmount !==
                            task.receipt.detailAmount
                          "
                        >
                          <td class="col-label" colspan="4">
                            <strong class="text-hint">Thành tiền</strong>
                          </td>
                          <td colspan="3" class="col-number">
                            <strong class="text-primary">
                              {{ task.receipt.totalAmount | number }}
                            </strong>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </nb-accordion-item-body>
              </nb-accordion-item>

              <nb-accordion-item>
                <nb-accordion-item-header>
                  <label class="label text-primary">
                    <nb-icon icon="people-outline"></nb-icon>
                    Người thực hiện
                  </label>
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                  <div class="table-responsive">
                    <table class="table table-striped">
                      <thead class="thead-light">
                        <tr>
                          <th scope="col" class="col-no">#</th>
                          <th scope="col" class="col-checkbox">Nhân viên</th>
                          <th scope="col">Vai trò</th>
                          <th scope="col" class="col-action"></th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr *ngFor="let item of task.processors; let i = index">
                          <th scope="row"># {{ i + 1 }}</th>
                          <td>
                            {{ item.employee.fullName }}
                          </td>
                          <td>
                            <input
                              nbInput
                              fullWidth
                              class="form-control"
                              [(ngModel)]="item.role"
                            />
                          </td>

                          <td>
                            <button
                              nbButton
                              shape="round"
                              outline
                              size="tiny"
                              status="danger"
                              [disabled]="submitted"
                              [class.btn-pulse]="submitted"
                              (click)="removeProcessor(item)"
                            >
                              <nb-icon icon="trash-2-outline"></nb-icon>
                              <span>Xóa</span>
                            </button>
                          </td>
                        </tr>
                      </tbody>

                      <tfoot>
                        <tr>
                          <th scope="row"># -</th>
                          <td>
                            <ng-select
                              class="form-control custom"
                              [placeholder]="
                                processorEmp ? '' : 'Chọn người thực hiện'
                              "
                              [(ngModel)]="processorEmp"
                            >
                              <ng-option
                                *ngFor="let opt of employees"
                                [value]="opt"
                              >
                                {{ opt.fullName }}
                              </ng-option>
                            </ng-select>
                          </td>

                          <td>
                            <div>
                              <input
                                nbInput
                                fullWidth
                                placeholder="Nhập vai trò"
                                class="form-control"
                                #elProcessorRole
                                [(ngModel)]="processorRole"
                                (keydown.enter)="addProcessor()"
                              />
                            </div>
                          </td>

                          <td>
                            <button
                              nbButton
                              outline
                              fullWidth
                              status="info"
                              size="small"
                              [disabled]="submitted"
                              [class.btn-pulse]="submitted"
                              (click)="addProcessor()"
                            >
                              <nb-icon icon="plus-outline"></nb-icon>
                              Thêm
                            </button>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </nb-accordion-item-body>
              </nb-accordion-item>

              <nb-accordion-item (collapsedChange)="reply()">
                <nb-accordion-item-header>
                  <label class="label">
                    <a (click)="reply()" class="text-primary link">
                      <nb-icon icon="message-square-outline"></nb-icon>
                      Bình luận
                    </a>
                  </label>
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                  <ngx-view-comments
                    [workingTask]="task"
                    (onClose)="closeReply()"
                  >
                  </ngx-view-comments>
                </nb-accordion-item-body>
              </nb-accordion-item>
            </nb-accordion>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-3">
        <div class="form-group">
          <ngx-view-selection-object
            *ngIf="mode !== 'view'"
            [shopId]="shopId"
            [objectType]="'project'"
            [objectId]="task.projectId"
            [objectName]="task.projectName"
            [objects]="projects"
            (objectChange)="objectChange($event)"
          >
          </ngx-view-selection-object>
          <h6 *ngIf="mode === 'view'">
            {{ task.projectName }}
          </h6>
        </div>
        <div class="form-group">
          <label for="inputDob" class="label text-primary">
            Ngày thực hiện
          </label>
          <nb-form-field>
            <input
              nbInput
              shape="semi-round"
              fieldSize="small"
              [nbDatepicker]="issueDate"
              [(ngModel)]="task.issueDate"
            />
            <!-- <nb-datepicker #issueDate format="dd/MM/yyyy"></nb-datepicker> -->
            <nb-date-timepicker
              #issueDate
              format="dd/MM/yyyy HH:mm"
            ></nb-date-timepicker>
          </nb-form-field>
        </div>

        <div class="form-group">
          <label for="inputDob" class="label text-danger">
            Hạn hoàn thành
          </label>
          <nb-form-field>
            <input
              nbInput
              shape="semi-round"
              fieldSize="small"
              [nbDatepicker]="dueDate"
              [(ngModel)]="task.dueDate"
            />
            <!-- <nb-datepicker #dueDate format="dd/MM/yyyy"></nb-datepicker> -->
            <nb-date-timepicker
              #dueDate
              format="dd/MM/yyyy HH:mm"
            ></nb-date-timepicker>
          </nb-form-field>
        </div>

        <div class="form-group">
          <label class="label"> Gắn nhãn</label>
          <nb-tag-list (tagRemove)="onTagRemove($event)">
            <nb-tag *ngFor="let tree of trees" [text]="tree" removable></nb-tag>
            <input
              type="text"
              nbTagInput
              (tagAdd)="onTagAdd($event)"
              fullWidth
            />
          </nb-tag-list>
        </div>

        <div class="form-group">
          <label class="label"> Giám sát </label>
          <ngx-view-selection-object
            *ngIf="mode !== 'view'"
            [shopId]="shopId"
            [objectType]="'user'"
            [objectId]="task.assignBy"
            [objectName]="task.assignName"
            [objects]="users"
            (objectChange)="selectAssign($event)"
          >
          </ngx-view-selection-object>
          <h6 *ngIf="mode === 'view'">
            {{ task.assignName }}
          </h6>
        </div>

        <div *ngIf="mode === 'edit'" class="form-group">
          <label class="label">
            <strong>{{ task.author.displayName }} </strong> tạo:
            {{ task.createdOn | date : "dd/MM/yyyy HH:mm" }}
          </label>
          <br />
          <label class="label">
            <strong> {{ task.updatedName }} </strong> cập nhật:
            <ngx-view-time-ago
              [currentDate]="task.updatedOn"
            ></ngx-view-time-ago>
          </label>
        </div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer *ngIf="!locked">
    <div>
      <button
        type="submit"
        nbButton
        hero
        status="primary"
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="submit(false)"
      >
        <nb-icon icon="save-outline"></nb-icon>
        {{ "buttons.save" | translate }}
      </button>

      <button
        type="submit"
        nbButton
        outline
        status="success"
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="submit(true)"
      >
        <nb-icon icon="save-outline"></nb-icon>
        {{ "buttons.save" | translate }} & {{ "buttons.create" | translate }}
      </button>
    </div>

    <button
      nbButton
      outline
      status="basic"
      size="small"
      (click)="print()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
      id="btnPrint"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      In
    </button>

    <div *ngIf="mode === 'edit'">
      <button
        nbButton
        outline
        status="warning"
        size="small"
        shape="semi-round"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="moveToTrash()"
      >
        <nb-icon icon="menu-arrow-outline"></nb-icon>
        Hủy
      </button>

      <button
        nbButton
        status="danger"
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="remove()"
      >
        <nb-icon icon="trash-2-outline"></nb-icon>
        {{ "buttons.delete" | translate }}
      </button>
    </div>
  </nb-card-footer>
</nb-card>
